module.exports = __webpack_public_path__ + "static/img/productDatabase_active.cf2a8a3b.svg";